import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { AiOutlineDelete } from "react-icons/ai";
import editProfileUser from "../../../assets/images/others/host-side-images/editProfileUSer.png";
import { ReactComponent as EditProfilePersonal } from "../../../assets/images/svgs/edit-profiles.svg";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import useStore from "hooks/useStore";
import { GENDERS } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { warningToaster } from "utils/helpers/common/alert-service";
import statesData from "components/dummyData/states.json";
import useRsvp from "../useHooks";
import { RsvpProfileDTO } from "utils/helpers/models/rsvp/edit-rsvp-profile.dto";
import RsvpBreadcrumb, { RsvpBreadcrumbLink } from "components/breadcrumbs/RsvpBreadcrumb";
const statesList = statesData.states;

const RsvpEditProfile: React.FC = () => {
  const [formData, setFormData] = useState<RsvpProfileDTO>(
    new RsvpProfileDTO()
  );
  const [rsvpProfileData, setRsvpProfileData] = useState<RsvpProfileDTO>(
    new RsvpProfileDTO()
  );
  const [cityList, setCityList] = useState<string[]>([]);
  const { updateRsvp, uploadFile, getRsvpProfile } = useRsvp();
  const breadcrumbLinks: RsvpBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.rsvpHome },
    { title: "Edit Profile", path: siteRoutes.rsvpEditProfile },
  ];

  useEffect(() => {
    getRsvpProfile(setRsvpProfileData);
  }, []);

  const { getUser } = useStore();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm<RsvpProfileDTO>({
    defaultValues: {
    },
  });

  const [profileImage, setProfileImage] = useState<string | null>(null);

  useEffect(() => {
    if (rsvpProfileData?.profilePicUrl?.fileDownloadUri) {
      setProfileImage(rsvpProfileData?.profilePicUrl?.fileDownloadUri);
    }
  }, [rsvpProfileData]);


  useEffect(() => {
    if (formData?.state) {
      const selectedState = statesList.find(
        (state: any) => state.name === formData.state
      );
      if (selectedState && selectedState.cities) {
        setCityList(selectedState.cities.map((city: any) => city.name));
      }
    }
  }, [formData?.state, statesList]);


  useEffect(() => {
    if (rsvpProfileData) {
      reset({
        firstName: rsvpProfileData.firstName || "",
        lastName: rsvpProfileData.lastName || "",
        email: rsvpProfileData.email || "",
        language: rsvpProfileData.language || "",
        dob: rsvpProfileData.dob || "",
        gender: rsvpProfileData.gender || "",
        profilePicId: rsvpProfileData?.profilePicUrl?.id || 0,
        profilePicUrl: rsvpProfileData?.profilePicUrl?.fileDownloadUri || "",
      });
      setFormData({
        ...rsvpProfileData,
      });
    }
  }, [rsvpProfileData, reset]);




  const { user } = getUser();
  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setProfileImage(previewUrl);
      setValue("profilePicUrl", file.name, { shouldValidate: true });

      try {
        const uploaded = await uploadFile(file);
        if (uploaded?.id) {
          setValue("profilePicId", uploaded.id, { shouldValidate: true });
        }
      } catch (error) {
        console.error("Upload failed", error);
      }
    }
  };

  // Handler for deleting the selected image
  const handleImageDelete = () => {
    setProfileImage(null);
    setValue("profilePicUrl", "");
    setValue("profilePicId", 0);
  };



  const onSubmit: SubmitHandler<RsvpProfileDTO> = (data) => {
    data.firstName = rsvpProfileData.firstName;
    data.lastName = rsvpProfileData.lastName;
    data.email = rsvpProfileData.email;

    if (!data.profilePicId) {
      warningToaster(
        "Please upload a profile picture before updating your profile."
      );
      return;
    }
    updateRsvp(user?.id, data);
  };

  return (
    <div className="container my-10">
      <RsvpBreadcrumb links={breadcrumbLinks} />

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Profile Picture */}
        <div className="flex flex-col  my-8">
          <div className="relative">
            <img
              src={concatPathWithBackendUrl(profileImage) || editProfileUser}
              alt="Profile"
              className="w-36 h-36 rounded-full object-cover"
            />
            {profileImage ? (
              <button
                type="button"
                onClick={handleImageDelete}
                className="absolute bottom-0 left-24 bg-red-500 text-white p-2 rounded-full cursor-pointer"
              >
                <AiOutlineDelete />
              </button>
            ) : (
              <label
                htmlFor="profileImage"
                className="absolute bottom-0 left-24 bg-white shadow p-2 rounded-full cursor-pointer"
              >
                <EditProfilePersonal />
              </label>
            )}
            <input
              id="profileImage"
              type="file"
              accept="image/*"
              className="hidden"
              {...register("profilePicId", {
                required: false,
              })}
              onChange={handleImageChange}
            />
          </div>
          {errors.profilePicId && (
            <p className="text-red-500 text-sm mt-2">
              {errors.profilePicId.message}
            </p>
          )}
          <p className="text-base font-semibold mt-4">Upload Profile Picture</p>
        </div>

        {/* Form Fields */}
        <div className="w-full my-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* First Name */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              First name
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("firstName", { required: "First name is required" })}
              // value={formData.firstName}
              // onChange={onChangeAdress}
              disabled
            />
            {errors.firstName && (
              <p className="text-red-500 text-sm">{errors.firstName.message}</p>
            )}
          </div>

          {/* Last Name */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Last name
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("lastName", { required: "Last name is required" })}
              disabled
            />
            {errors.lastName && (
              <p className="text-red-500 text-sm">{errors.lastName.message}</p>
            )}
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Email
            </label>
            <input
              type="email"
              className="w-full h-[51px] px-2 rounded-lg border-[0.6px] border-inputsBorderColor outline-none"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: "Enter a valid email",
                },
              })}

            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}
          </div>

          {/* Language */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Language
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none"
              {...register("language", { required: "Language is required" })}

            />
            {errors.language && (
              <p className="text-red-500 text-sm">{errors.language.message}</p>
            )}
          </div>

          {/* Date of Birth */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Date of Birth
            </label>
            <input
              type="date"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none"
              {...register("dob", { required: "Date of Birth is required" })}

            />
            {errors.dob && (
              <p className="text-red-500 text-sm">{errors.dob.message}</p>
            )}
          </div>

          {/* Gender */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">Gender</label>
            <select
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none"
              {...register("gender", { required: "Gender is required" })}

            >
              <option value="">Select Gender</option>
              {Object.values(GENDERS).map((gender, index) => {
                return (
                  <option className="capitalize" value={gender} key={index}>
                    {gender}
                  </option>
                );
              })}
            </select>
            {errors.gender && (
              <p className="text-red-500 text-sm">{errors.gender.message}</p>
            )}
          </div>


        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-primaryBlueBg text-white rounded-full mt-4 md:mt-8"
        >
          Update
        </button>
      </form>
    </div>
  );
};

export default RsvpEditProfile;

